// Beállítások → Webshopok (7.1): the sentences of the shop table, apart from
// the page so they run on Node in the admin tests (tests/admin/
// test_webshops_model.py). The API is the authority on every state; this only
// says it in Hungarian.

import { count } from "@/components/emc/format";
import type { ShopifyBackfillProgress, ShopifyStoreLine } from "@/lib/api";

/** The order the backfill kinds are read in, and their names. */
export const BACKFILL_KINDS: { kind: string; label: string }[] = [
  { kind: "customers", label: "vásárlók" },
  { kind: "orders", label: "rendelések" },
  { kind: "products", label: "termékek" },
  { kind: "variants", label: "változatok" },
];

/** "17/18", and why not all of them, in one line. */
export function webhookLine(line: ShopifyStoreLine): string {
  const base = `${line.webhooks_registered}/${line.webhooks_wanted}`;
  if (line.webhooks_error) return `${base} — hiba: ${line.webhooks_error}`;
  if (line.webhooks_checked_at === null) return `${base} — még nem regisztrált`;
  if (line.webhooks_missing.length > 0) return `${base} — hiányzik: ${line.webhooks_missing.join(", ")}`;
  return base;
}

/** One kind's progress: "1 500 / 4 000 sor", or the reason it stopped. */
export function backfillLine(progress: ShopifyBackfillProgress | undefined): string {
  if (progress === undefined) return "nem futott";
  const total = progress.object_count === null ? "" : ` / ${count(progress.object_count)}`;
  const lines = `${count(progress.lines_done)}${total} sor`;
  if (progress.state === "failed") return `${lines} — ${progress.error ?? "hiba"}`;
  return lines;
}

/** What needs a person, if anything: the line under the shop's name. */
export function attention(line: ShopifyStoreLine): string | null {
  if (line.uninstalled_at !== null) return "Az appot eltávolították a boltból.";
  if (!line.configured) return "Már nincs a beállításokban; az előzményei megmaradtak.";
  if (line.inbox_failed > 0) return `${line.inbox_failed} webhook nem dolgozható fel (requeue kézzel).`;
  if (line.token_state === "expired" || line.token_state === "none") {
    return line.token_error ? `Nincs érvényes token: ${line.token_error}` : null;
  }
  return null;
}
